/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect } from 'react'
import { useRouter } from 'next/router'
import '@styles/globals.css'

import { Providers } from 'context'
import { UsersApi } from '@services/api/users'
import { getTokenCookie, getTokenDecoded } from '@utils/auth-cookie'
import Head from 'next/head'
import { saveViewPages } from '@utils/view-counter'

declare const window: any

const App = ({ Component, pageProps }) => {
  const router = useRouter()

  const setTransitionComplete = () => {
    saveInfoUser(window.location.pathname)
  }

  const saveInfoUser = (path: string) => {
    if (!path.includes('/admin/')) {
      saveViewPages(window.location.pathname)
    } else {
      const { user_id } = getTokenDecoded()

      user_id &&
        !!getTokenCookie() &&
        UsersApi.patch(user_id, { last_access: new Date() })
    }
  }

  useEffect(() => {
    saveInfoUser(router.asPath)
    router.events.on('routeChangeComplete', () => setTransitionComplete())

    if (process.env.NODE_ENV !== 'development') {
      console.log = function () {}
      console.error = function () {}
      console.warn = function () {}
    }

    return () => {
      router.events.off('routeChangeComplete', setTransitionComplete)
    }
  }, [])

  return (
    <Providers>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <Component {...pageProps} />
    </Providers>
  )
}

export default App
